var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDesking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25846_51733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875 7.33333H17.4166V4.125C17.4166 1.85075 15.5659 9.61651e-07 13.2916 9.61651e-07H8.7083C6.43405 9.61651e-07 4.5833 1.85075 4.5833 4.125V7.33333H4.12496C2.3558 7.33333 0.916629 8.7725 0.916629 10.5417V15.125C0.916629 16.3891 1.94513 17.4167 3.2083 17.4167H10.5416V21.0833H5.9583C5.7053 21.0833 5.49996 21.2887 5.49996 21.5417C5.49996 21.7947 5.7053 22 5.9583 22H16.0416C16.2946 22 16.5 21.7947 16.5 21.5417C16.5 21.2887 16.2946 21.0833 16.0416 21.0833H11.4583V17.4167H18.7916C20.0548 17.4167 21.0833 16.3891 21.0833 15.125V10.5417C21.0833 8.7725 19.6441 7.33333 17.875 7.33333ZM17.875 8.25C19.1381 8.25 20.1666 9.27758 20.1666 10.5417V13.2926C19.7835 13.0038 19.3068 12.8333 18.7916 12.8333H17.4166V8.25H17.875ZM5.49996 4.125C5.49996 2.35583 6.93913 0.916668 8.7083 0.916668H13.2916C15.0608 0.916668 16.5 2.35583 16.5 4.125V12.8333H5.49996V4.125ZM4.12496 8.25H4.5833V12.8333H3.2083C2.69313 12.8333 2.21646 13.0048 1.8333 13.2926V10.5417C1.8333 9.27758 2.8618 8.25 4.12496 8.25ZM18.7916 16.5H3.2083C2.45021 16.5 1.8333 15.8831 1.8333 15.125C1.8333 14.3669 2.45021 13.75 3.2083 13.75H18.7916C19.5497 13.75 20.1666 14.3669 20.1666 15.125C20.1666 15.8831 19.5497 16.5 18.7916 16.5Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25846_51733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDesking);
export default __webpack_public_path__ + "static/media/green-desking.b3c776bc8f8f03842bccc3a6e3025d97.svg";
export { ForwardRef as ReactComponent };